import { useLayers } from "../../context/LayersContext";
import {
  DEFAULT_TILE,
  MAP_MAX_ZOOM,
  Tiles,
  TILE_CONFIG,
} from "../../global/constants/tiles";
import { TileLayer } from "react-leaflet";

export default function MapTileLayer() {
  const { tile } = useLayers();
  const config = TILE_CONFIG[tile as Tiles] ?? TILE_CONFIG[DEFAULT_TILE];

  return (
    <TileLayer
      key={tile}
      url={tile}
      maxZoom={MAP_MAX_ZOOM}
      maxNativeZoom={config.maxNativeZoom}
      attribution={config.attribution}
      crossOrigin="anonymous"
    />
  );
}
